var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1628_15830",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1628_15830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1 11.1L0 9C1.58333 7.38333 3.4125 6.14583 5.4875 5.2875C7.5625 4.42917 9.73333 4 12 4C12.4 4 12.8 4.0125 13.2 4.0375C13.6 4.0625 14 4.1 14.4 4.15L12.9 7.05C12.75 7.03333 12.6 7.02083 12.45 7.0125C12.3 7.00417 12.15 7 12 7C10.1333 7 8.34583 7.35417 6.6375 8.0625C4.92917 8.77083 3.41667 9.78333 2.1 11.1ZM6.35 15.35L4.25 13.2C5.2 12.25 6.29167 11.5083 7.525 10.975C8.75833 10.4417 10.05 10.1333 11.4 10.05L9.8 13.325C9.15 13.5083 8.53333 13.7708 7.95 14.1125C7.36667 14.4542 6.83333 14.8667 6.35 15.35ZM11.3 19.85C10.75 19.6667 10.35 19.3208 10.1 18.8125C9.85 18.3042 9.85 17.8 10.1 17.3L16.1 5.1C16.1667 4.96667 16.2667 4.87917 16.4 4.8375C16.5333 4.79583 16.6667 4.8 16.8 4.85C16.9333 4.9 17.0333 4.9875 17.1 5.1125C17.1667 5.2375 17.1833 5.36667 17.15 5.5L13.9 18.65C13.7667 19.2 13.4375 19.5917 12.9125 19.825C12.3875 20.0583 11.85 20.0667 11.3 19.85ZM17.65 15.35C17.5333 15.2333 17.4208 15.1292 17.3125 15.0375C17.2042 14.9458 17.0833 14.85 16.95 14.75L17.75 11.625C18.1 11.8583 18.4458 12.1042 18.7875 12.3625C19.1292 12.6208 19.45 12.9 19.75 13.2L17.65 15.35ZM21.875 11.125C21.3417 10.6417 20.7958 10.1833 20.2375 9.75C19.6792 9.31667 19.0833 8.93333 18.45 8.6L19.15 5.6C20.05 6.03333 20.9083 6.53333 21.725 7.1C22.5417 7.66667 23.3 8.3 24 9L21.875 11.125Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkCheck);
export default __webpack_public_path__ + "static/media/network_check.635ea2c462c54a4d4f3b66c3e42b2ce8.svg";
export { ForwardRef as ReactComponent };